import { useMemo } from 'react';
import { useAppData } from './use-app-data';

export type FeatureFlags = { Name: string; Enabled: boolean }[];

/**
 * Check if one or more feature flags are enabled.
 * @param featureSet The list of feature flags.
 * @param keys The feature flag(s) to check if enabled.
 * @returns The feature flag(s) are enabled.
 */
export function hasFeature(
    featureSet: FeatureFlags,
    keys: string | string[]
): boolean {
    const featureKeys = Array.isArray(keys) ? keys : [keys];

    return featureKeys.every((key) => {
        return featureSet.find((item) => item?.Name === key)?.Enabled;
    });
}

/**
 * Hook to check if one or more feature flags are enabled.
 * @param feature The feature flag(s) to check.
 * @returns The feature flag(s) are enabled.
 */
export function useFeature(feature: string | string[]) {
    const featureFlags = useAppData().featureFlags;
    return useMemo(
        () => hasFeature(featureFlags, feature),
        [featureFlags, feature]
    );
}
